import { render } from "./ColorfulTone.vue?vue&type=template&id=ca8ba89a"
import script from "./ColorfulTone.vue?vue&type=script&lang=js"
export * from "./ColorfulTone.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__